export class State {
    public environment: string | null = null;
    public version: string | null = null;
}
